document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('.countdown-timer').forEach(function(timer) {

    const hours = parseInt(timer.dataset.hours) || 24;

    let endTime = localStorage.getItem('offer_end_time');

    if (!endTime) {
      endTime = new Date().getTime() + (hours * 60 * 60 * 1000);
      localStorage.setItem('offer_end_time', endTime);
    }

    function updateCountdown() {

      const now = new Date().getTime();
      const distance = endTime - now;

      if (distance <= 0) {

        endTime = new Date().getTime() + (hours * 60 * 60 * 1000);
        localStorage.setItem('offer_end_time', endTime);

        return;
      }

      const h = Math.floor(distance / (1000 * 60 * 60));
      const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const s = Math.floor((distance % (1000 * 60)) / 1000);

      timer.innerHTML =
        String(h).padStart(2, '0') + 'h : ' +
        String(m).padStart(2, '0') + 'm : ' +
        String(s).padStart(2, '0') + 's';
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);

  });

});

/* Nettoyage v4 (2026-10-11) : compteur de visiteurs aleatoire (.live-viewers) retire, il affichait un faux nombre. */
